import TruckIcon from "@heroicons/react/outline/TruckIcon";
import { FC, Fragment, useState } from "react";
import Link from "next/link";
import { Transition } from "@headlessui/react";
import { Product } from "@prisma/client";
import { useRouter } from "next/router";
import { useTranslation } from "next-i18next";

import QuantityInput from "./quantity-input";

import { ActionType } from "@interfaces/cart";
// import { formatDate } from "@utils/datetime";
import { useCart } from "@context/cart";
import CartItem from "@components/common/cart-item";

interface Props {
  product: Product;
}

const AddToCartComponent: FC<Props> = ({ product }) => {
  const [quantity, setQuantity] = useState(1);
  const [animate, setAnimate] = useState(false);
  const { dispatch } = useCart();
  const router = useRouter();
  const { t } = useTranslation("product", { keyPrefix: "add-to-cart" });
  // const currentDate = new Date();
  const lower = product.numInStock ? 1 : 15;
  const upper = product.numInStock ? 5 : 30;

  return (
    <div className="pt-4">
      <div className="flex flex-row">
        <TruckIcon className="h-6 w-8 text-black hover:text-red-400 transition-color duration-200" />
        <div>
          {t("order-now")} <b>{lower}</b> {t("and")} <b>{upper}</b> {t("days")}
        </div>
      </div>
      {product.numInStock > 0 && (
        <div className="pt-2">
          {t("installments")}{" "}
          <Link
            href={{
              pathname: "/inquiry/[category]",
              query: {
                category: product.categorySlug,
                url: `${router.asPath}`,
              },
            }}
          >
            <a className="font-semibold hover:underline">{t("here")}</a>
          </Link>
        </div>
      )}
      <div className="flex flex-row p-6 justify-between">
        <QuantityInput
          {...{
            quantity,
            increase: () => setQuantity((old) => old + 1),
            decrease: () => setQuantity((old) => old - 1),
            set: setQuantity,
          }}
        />
        <div className="w-4/6 flex space-x-2">
          <button
            className="text-center transition-all duration-200 focus:outline-none w-1/2 h-full rounded bg-green-500 hover:bg-black hover:text-white hover:text-lg"
            onClick={() => {
              dispatch({
                type: ActionType.ADD_TO_CART,
                product,
                count: quantity,
              });
              setTimeout(() => router.push("/checkout"), 10);
            }}
          >
            {t("buy-now")}
          </button>
          <button
            className="text-center transition-all duration-200 focus:outline-none w-1/2 h-full rounded bg-gray-400 hover:bg-black hover:text-white hover:text-lg"
            onClick={() => {
              dispatch({
                type: ActionType.ADD_TO_CART,
                product,
                count: quantity,
              });
              setAnimate(true);
              setTimeout(() => setAnimate(false), 400);
            }}
          >
            {t("add")}
          </button>
        </div>
      </div>
      <Transition
        show={animate}
        as={Fragment}
        enter="transition-all duration-200 ease-out"
        enterFrom="opacity-80 scale-75"
        enterTo="opacity-100 scale-100"
        leave="transition-all duration-200 ease-in origin-top-right"
        leaveFrom="opacity-100 scale-100"
        leaveTo="opacity-80 scale-50"
      >
        <div className="max-w-screen-md px-6 absolute z-10 top-0 right-4">
          <CartItem {...{ product, count: quantity }} />
        </div>
      </Transition>
    </div>
  );
};

export default AddToCartComponent;
